import { useLanguage } from '../../context/Languagecontext';
import {Globals as OldGlobals} from '../../global/Globals';
import './Footer.css';

export default function Footer() {
    const { Globals, languages, setLanguages } = useLanguage();
    const openCommissioningProtocol = () => {
        if (languages === OldGlobals.LANGUAGE_KEYS.PORTUGESE) {
            window.open(OldGlobals.FILES.COMMISSIONNING_PROTOCOL_PT, '_blank', 'noopener, noreferrer')
        }
        else if (languages === OldGlobals.LANGUAGE_KEYS.AHMARIC) {
            window.open(OldGlobals.FILES.COMMISSIONNING_PROTOCOL_AH, '_blank', 'noopener, noreferrer')
        }
        else if (languages === OldGlobals.LANGUAGE_KEYS.KISWAHILI) {
            window.open(OldGlobals.FILES.COMMISSIONNING_PROTOCOL_KW, '_blank', 'noopener, noreferrer')
        }
        else {
            window.open(OldGlobals.FILES.COMMISSIONNING_PROTOCOL, '_blank', 'noopener, noreferrer')
        }
    }

    const openPrivacy = () => {
        window.open(Globals.EXTERNAL_LINKS.PRIVACY_NOTICE_URL, '_blank', 'noopener noreferrer');
    }
        ;
    return (
        <div className="Footer-Wrapper">
            <div className="Footer">
                <div className="Footer-Items">
                    <div className='version'>{Globals.INTERNAL.VERSION} {process.env.REACT_APP_VERSION}</div>
                    <div className="footer-separator" />
                    <div className="copyrights">{Globals.FOOTER.ALL_RIGHTS}</div>
                    <div className="footer-separator" />
                    <div className="protocol cursor" onClick={() => { openCommissioningProtocol() }}>{Globals.SIGNUP.COMMISSIONG_PROTOCOL}</div>
                    <div className="footer-separator" />
                    <div className="privacy cursor" onClick={openPrivacy}>{Globals.SIGNUP.PRIVACY_POLICY}</div>
                    {(window.location.pathname !== Globals.NAVPATH.SIGNUP && window.location.pathname !== Globals.NAVPATH.ROOT) && <><div className="footer-separator" />
                        <div className="footer-query">
                            <span className="footer-query-email-string">{Globals.EMAIL_QUERY_STRING}</span><b className="footer-query-email-txt">{Globals.EMAIL_QUERY}</b>
                        </div>
                    </>}
                </div>
            </div>
        </div>

    )
}